<template>
  <div class="OAHandle">
    <div @click="onClick(scope)" class="linkClass" v-show="show">{{text||scope.row[textKey]}}</div>
  </div>
</template>

<script>
  export default {
    name: "OAHandle",
    props: {
      textKey: {
        default: null
      },
      text: {
        default: null
      },
      onClick: {
        default: null
      },
      scope: {
        default: null
      },
      isShow: {
        default: null
      }
    },
    watch: {
      isShow: {
        handler: function (val) {
          if (val) {
            this.show = eval("this.scope.row." + val);
          }
        },
        immediate: true
      }
    },
    data() {
      return {
        show: true
      };
    },
    mounted() {},
    methods: {}
  };

</script>
<style lang="scss" scoped>
  .linkClass {
    color: #409eff;
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/components/OAHandle/OAHandle.vue